export interface IAnagraficaCustom {
    idAnagrafica: string,
    ragioneSociale: string,
    ragioneSocialeCustom: string,
    destinatari: ReadonlyArray<IDestinatarioCustom>
}

export interface IDestinatarioCustom {
    idDestinatario: string,
    destinatario: string,
    destinatarioCustom: string
}

export interface AnagraficaCustomModificata {
    idAnagrafica: string,
    ragioneSocialeCustom: string,
}
export interface DestinatarioCustomModificato {
    idDestinatario: string,
    idAnagrafica: string,
    destinatarioCustom: string
}

export class AnagraficaCustom implements IAnagraficaCustom {

    private ragioneSocialeOriginale: string;

    public idAnagrafica: string;
    public ragioneSociale: string;
    public ragioneSocialeCustom: string;
    public destinatari: DestinatarioCustom[];

    constructor(anagrafica: IAnagraficaCustom) {
        this.idAnagrafica = anagrafica.idAnagrafica;
        this.ragioneSociale = anagrafica.ragioneSociale;
        this.ragioneSocialeOriginale = anagrafica.ragioneSocialeCustom === null ? "" : anagrafica.ragioneSocialeCustom;
        this.ragioneSocialeCustom = anagrafica.ragioneSocialeCustom === null ? "" : anagrafica.ragioneSocialeCustom;
        
        this.destinatari = anagrafica.destinatari.map(d => new DestinatarioCustom(d, anagrafica.idAnagrafica));
    }

    isModificata = () => this.ragioneSocialeCustom !== this.ragioneSocialeOriginale;

    modifica = (value: string) => {
        this.ragioneSocialeCustom = value;
    }

    conferma = () => {
        this.ragioneSocialeOriginale = this.ragioneSocialeCustom;

        this.destinatari.forEach(d => d.conferma());
    }
}

export class DestinatarioCustom implements IDestinatarioCustom {
    private destinatarioOriginale: string;

    public idDestinatario: string;
    public idAnagrafica: string;
    public destinatario: string;
    public destinatarioCustom: string;    

    constructor(dest: IDestinatarioCustom, idAnagrafica: string) {
        this.idDestinatario = dest.idDestinatario;
        this.idAnagrafica = idAnagrafica;
        this.destinatario = dest.destinatario;
        this.destinatarioOriginale = dest.destinatarioCustom === null ? "" : dest.destinatarioCustom;
        this.destinatarioCustom = dest.destinatarioCustom === null ? "" : dest.destinatarioCustom;
    }

    isModificato = () => this.destinatarioCustom !== this.destinatarioOriginale;
    
    modifica = (value: string) => {
        this.destinatarioCustom = value;
    }

    conferma = () => {
        this.destinatarioOriginale = this.destinatarioCustom;
    }
}

/////////////////////////////////////////////////////////////////

export interface IUbicazioneCustom {
    idSpecifica: string,
    matricola: string,
    numeroMacchina: string,
    destinatario: string,
    edificio: string,
    piano: string,
    ufficio: string,
    referente: string,
    attrezzatura: string,
}

export interface UbicazioneModificata {
    idSpecifica: string,
    edificioNuovo: string,
    pianoNuovo: string,
    ufficioNuovo: string,
    referenteNuovo: string,
}

export class UbicazioneCustom implements IUbicazioneCustom {
    public idSpecifica: string;
    public matricola: string;
    public numeroMacchina: string;
    public destinatario: string;
    public edificio: string;
    public piano: string;
    public ufficio: string;
    public referente: string;
    public attrezzatura: string;

    public edificioNuovo: string;
    public pianoNuovo: string;
    public ufficioNuovo: string;
    public referenteNuovo: string;

    constructor(ubicazione: IUbicazioneCustom) {
        this.idSpecifica = ubicazione.idSpecifica;
        this.matricola = ubicazione.matricola;
        this.numeroMacchina = ubicazione.numeroMacchina;
        this.destinatario = ubicazione.destinatario;
        this.attrezzatura = ubicazione.attrezzatura;
        //this.ubicazione = ubicazione.ubicazione === null ? "" : ubicazione.ubicazione;
        //this.ubicazioneNuova = ubicazione.ubicazione === null ? "" : ubicazione.ubicazione;
        
        this.edificio = ubicazione.edificio === null ? "" : ubicazione.edificio;
        this.piano = ubicazione.piano === null ? "" : ubicazione.piano;
        this.ufficio = ubicazione.ufficio === null ? "" : ubicazione.ufficio;
        this.referente = ubicazione.referente === null ? "" : ubicazione.referente;
        
        this.edificioNuovo = ubicazione.edificio === null ? "" : ubicazione.edificio;
        this.pianoNuovo = ubicazione.piano === null ? "" : ubicazione.piano;
        this.ufficioNuovo = ubicazione.ufficio === null ? "" : ubicazione.ufficio;
        this.referenteNuovo = ubicazione.referente === null ? "" : ubicazione.referente;
    }

    isModificatoEdificio = (): boolean => {
        return this.edificio !== this.edificioNuovo;
    }

    isModificatoPiano = (): boolean => {
        return this.piano !== this.pianoNuovo;
    }

    isModificatoUfficio = (): boolean => {
        return this.ufficio !== this.ufficioNuovo;
    }

    isModificatoReferente = (): boolean => {
        return this.referente !== this.referenteNuovo;
    }

    isModificata = (): boolean => {
        return this.isModificatoEdificio() ||
               this.isModificatoPiano() ||
               this.isModificatoReferente() ||
               this.isModificatoUfficio();
    }

    setEdificio = (value: string) => {
        this.edificioNuovo = value;
    }

    setPiano = (value: string) => {
        this.pianoNuovo = value;
    }

    setUfficio = (value: string) => {
        this.ufficioNuovo = value;
    }

    setReferente = (value: string) => {
        this.referenteNuovo = value;
    }

    conferma = () => {
        this.edificio = this.edificioNuovo;
        this.piano = this.pianoNuovo;
        this.ufficio = this.ufficioNuovo;
        this.referente = this.referenteNuovo;
    }

    annulla = () => {
        this.edificioNuovo = this.edificio;
        this.pianoNuovo = this.piano;
        this.ufficioNuovo = this.ufficio;
        this.referenteNuovo = this.referente;
    }
}

/////////////////////////////////////////////////////////////////

export interface UserAdminState {
    anagrafiche: ReadonlyArray<AnagraficaCustom>,    
    ubicazioni: ReadonlyArray<UbicazioneCustom>,
}